import http from '@core/fetch'

export default {
  getStaticData: body =>
    http('/p/wedding/index.php/admin/APIADCenter/index', { body }),
  zhiTuiBaoAnalysisData: body =>
    http(
      '/p/wedding/index.php/admin/CpmBalance/flow_packet_dashboard_statistics',
      { body }
    ),
  zhiGuangTongAnalysisData: body =>
    http('/p/wedding/index.php/admin/CpmBalance/dashboard_statistics', { body })
}
